<template>
    <kt-panel>
        <kt-row v-for="(card, index) in form_data.bank_cards"
                v-bind:key="index">
            <form :id="'update_bank_card'+index">
                <kt-row>
                    <kt-col xs="12" lg="6">
                        <kt-form-group>
                            <kt-form-label for="card_number">
                                {{ $t('label.card_number') }}
                            </kt-form-label>
                            <kt-form-control
                                id="card_number"
                                name="card_number"
                                v-model="card.card_number"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" lg="6">
                        <kt-form-group>
                            <kt-form-label for="account_number">
                                {{ $t('label.account_number') }}
                            </kt-form-label>
                            <kt-form-control
                                id="account_number"
                                name="account_number"
                                v-model="card.account_number"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" lg="6">
                        <kt-form-group>
                            <kt-form-label for="card_owner_name">
                                {{ $t('card_to_card.card_owner_name') }}
                            </kt-form-label>
                            <kt-form-control
                                id="card_owner_name"
                                name="card_owner_name"
                                v-model="card.card_owner_name"
                                dir="rtl"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" lg="6">
                        <kt-form-group>
                            <kt-form-label for="bank_id">
                                {{ $t('label.bank') }}
                            </kt-form-label>
                            <kt-form-control
                                id="bank_id"
                                name="bank_id"
                                disabled
                                :value="getBankName(index)"
                                dir="rtl"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" lg="6">
                        <kt-form-group>
                            <kt-form-label for="username">
                                {{ $t('label.username') }}
                            </kt-form-label>
                            <kt-form-control
                                id="username"
                                name="username"
                                v-model="card.access_info.username"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" lg="6">
                        <kt-form-group>
                            <kt-form-label for="password">
                                {{ $t('label.password') }}
                            </kt-form-label>
                            <kt-form-control
                                id="password"
                                name="password"
                                v-model="card.access_info.password"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" style="text-align: end">
                        <kt-form-action class="mt-4">
                            <kt-button
                                class="m-2"
                                size="md"
                                variant="success"
                                type="button"
                                @click="editCard(index)"
                                v-bind:wide="true"
                                :id="'update_bank_card_btn'+index"
                            >
                                {{ $t('btn.edit') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-col>
                </kt-row>
                <hr v-if="form_data.bank_cards.length != index+1" style="margin-bottom: 35px">
            </form>
        </kt-row>
    </kt-panel>
</template>

<script>
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import {KTApp} from '@/plugins/core/app'
import {mapGetters} from "vuex";
import {cardToCardService} from "@/common/api.service";

export default {
    components: {},
    mounted() {
        this.afterDispatch()
    },
    computed: {
        ...mapGetters('cardToCard', [
            'form_data', 'status'
        ]),
    },
    data() {
        return {}
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        editCard(index) {
            let btn = $('#update_bank_card_btn' + index)
            let form = $('#update_bank_card' + index)

            form.validate({
                rules: {
                    card_number: {
                        required: true
                    },
                    account_number: {
                        required: true
                    },
                    card_owner_name: {
                        required: true
                    },
                    username: {
                        required: true
                    },
                    password: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                return
            }

            for (var i = 0; i < this.form_data.bank_cards.length; i++) {
                if (i != index && this.form_data.bank_cards[i].card_number === this.form_data.bank_cards[index].card_number)
                    return this.toastr.error(i18n.t('card_to_card.message.card_number_is_duplicate'))
            }

            if (!this.validateCard(this.form_data.bank_cards[index].card_number))
                return this.toastr.error(i18n.t('card_to_card.message.card_number_is_not_valid'))

            var number = this.form_data.bank_cards[index].card_number.substring(6, -16);
            if (number != '603769')
                return this.toastr.error(i18n.t('card_to_card.message.bank_not_supported'))


            KTApp.progress(btn)
            let params = {
                card_number: this.form_data.bank_cards[index].card_number,
                account_number: this.form_data.bank_cards[index].account_number,
                card_owner_name: this.form_data.bank_cards[index].card_owner_name,
                username: this.form_data.bank_cards[index].access_info.username,
                password: this.form_data.bank_cards[index].access_info.password,
            }
            cardToCardService.adminUpdateGatewayCard(this.form_data.bank_cards[index].id, params).then(response => {
                this.showMsg(form, 'success', response.data.message);
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
            }).finally(response => {
                    KTApp.unprogress(btn);
                }
            )
        },
        validateCard(code) {
            var l = code.length;
            if (l < 16 || parseInt(code.substr(1, 10), 10) == 0 || parseInt(code.substr(10, 6), 10) == 0) return false;
            var c = parseInt(code.substr(15, 1), 10);
            var s = 0;
            var k, d;
            for (var i = 0; i < 16; i++) {
                k = (i % 2 == 0) ? 2 : 1;
                d = parseInt(code.substr(i, 1), 10) * k;
                s += (d > 9) ? d - 9 : d;
            }
            return ((s % 10) == 0);
        },
        getBankName(index) {
            var number = this.form_data.bank_cards[index].card_number.substring(6, -16);
            if (number === '603799') {
                return 'بانک ملی'
            }
            if (number === '589210') {
                return 'بانک سپه'
            }
            if (number === '627961') {
                return 'بانک صنعت و معدن'
            }
            if (number === '603770') {
                return 'بانک کشاورزی'
            }
            if (number === '628023') {
                return 'بانک مسکن'
            }
            if (number === '627760') {
                return 'پست بانک ایران'
            }
            if (number === '502908') {
                return 'بانک توسعه تعاون'
            }
            if (number === '627412') {
                return 'بانک اقتصادنوین'
            }
            if (number === '622106') {
                return 'بانک پارسیان'
            }
            if (number === '502229') {
                return 'بانک پاسارگاد'
            }
            if (number === '627488') {
                return 'بانک کارآفرین'
            }
            if (number === '621986') {
                return 'بانک سامان'
            }
            if (number === '639346') {
                return 'بانک سینا'
            }
            if (number === '639607') {
                return 'بانک سرمایه'
            }
            if (number === '502806' || number === '504706') {
                return 'بانک شهر'
            }
            if (number === '502938') {
                return 'بانک دی'
            }
            if (number === '603769') {
                return 'بانک صادرات'
            }
            if (number === '610433') {
                return 'بانک ملت'
            }
            if (number === '627353' || number === '585983') {
                return 'بانک تجارت'
            }
            if (number === '589463') {
                return 'بانک رفاه'
            }
            if (number === '627381') {
                return 'بانک انصار'
            }
            if (number === '639599') {
                return 'بانک قوامین'
            }
            if (number === '504172') {
                return 'بانک رسالت'
            }
            if (number === '606373') {
                return 'بانک مهر ایران'
            }
            if (number === '636214') {
                return 'بانک آینده'
            }
            if (number === '505785') {
                return 'بانک ایران زمین'
            }
            if (number === '627648' || number === '207177') {
                return 'بانک توسعه صادرات ایران'
            }
            if (number === '636949') {
                return 'بانک حکمت ایرانیان'
            }
            if (number === '505416') {
                return 'بانک گردشگری'
            }
            if (number === '636795') {
                return 'بانک مرکزی'
            }
        }
    },

}
</script>

<style>

</style>